import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CompanyPage from "../pages/company/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/company",
    element: <CompanyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
